import { ArticleCard } from '~/components'
import { ProductArticlesProps } from './ProductDetails.types'

export const ProductArticles = ({ items }: ProductArticlesProps) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-8'>
      {items.map((item, index) => {
        return <ArticleCard {...item} key={index} />
      })}
    </div>
  )
}
